import { getOrders, type OrderFilterDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_LIST = "ORDER_LIST";
export const getOrdersListQueryKey = (filter: OrderFilterDto) => [
	ORDER_LIST,
	filter.status,
	filter.dateNextActionFrom,
	filter.dateNextActionTo,
	filter.dateStartingFrom,
	filter.dateStartingTo,
	filter.isNew,
	filter.isHasClaim,
	filter.marketId,
	filter.partnerId,
	filter.unassignedPartner,
	filter.regionId,
	filter.userId,
	filter.unassignedUser,
	filter.query,
	filter.pageLimit,
	filter.pageIndex,
	filter.isDeleted,
	filter.orderBy,
	filter.orderDirection,
	filter.review,
	filter.notReviewed,
	filter.hasExamination,
	filter.claimDateNextActionFrom,
	filter.claimDateNextActionTo,
	filter.verticals,
	filter.b2b,
	filter.promoCode,
	filter.followUpAgentStatus,
];

export function useOrdersList(filter: OrderFilterDto) {
	return useQuery({
		queryKey: getOrdersListQueryKey(filter),
		queryFn: processResponse(() =>
			getOrders(
				filter.status ?? undefined,
				filter.dateNextActionFrom,
				filter.dateNextActionTo,
				filter.dateStartingFrom,
				filter.dateStartingTo,
				filter.isNew,
				filter.isHasClaim,
				filter.marketId,
				filter.partnerId,
				filter.unassignedPartner,
				filter.regionId,
				filter.userId,
				filter.unassignedUser,
				filter.query,
				filter.pageLimit,
				filter.pageIndex,
				filter.isDeleted,
				filter.orderBy,
				filter.orderDirection ?? undefined,
				filter.review ?? undefined,
				filter.notReviewed,
				filter.hasExamination,
				filter.claimDateNextActionFrom,
				filter.claimDateNextActionTo,
				filter.verticals,
				filter.b2b,
				filter.promoCode,
				filter.followUpAgentStatus ?? undefined,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
